import type { ReactNode } from "react";

import clsx from "clsx";

import { Typo } from "../Typo";

export type ChipProps = {
  children: ReactNode;
  bgClass?: string;
  textColorClass?: string;
  className?: string;
};

// `.chip` + `.chip--2xs`: 20px tall, fully rounded, `border: 0`, 4px padding on
// the chip plus 2px on the label — 6px effective. Not `rounded-md px-2 py-0.5`.
const CHIP_CLASSES =
  "inline-flex h-5 shrink-0 items-center whitespace-nowrap rounded-full px-1";

export const Chip = ({
  children,
  bgClass = "bg-surface-accent-blue-subtler",
  textColorClass = "text-text-accent-blue-boldest",
  className,
}: ChipProps) => (
  <span className={clsx(CHIP_CLASSES, bgClass, className)}>
    <Typo
      element="span"
      type="label2XS"
      textColor={textColorClass}
      className="whitespace-nowrap px-0.5"
    >
      {children}
    </Typo>
  </span>
);
